import { z } from 'zod';

export const CakeToOrderCardModelSchema = z.object({
    uid: z.string(),
    name: z.string(),
    image: z.object({
        url: z.string(),
    }).optional().nullable(),
});

export type CakeToOrderCardModel = z.infer<typeof CakeToOrderCardModelSchema>;
